<template>
  <UModal key="addToQuote" v-model:open="isOpen">
    <UButton
      :ui="{ base: 'p-2 rounded-sm shadow-lueur-bleu' }"
      :icon="iconName"
      size="md"
      color="primary"
      :disabled="!props.isAuthenticated || isAdding"
      class="dj-add-to-quote-btn"
      :loading="isAdding"
      @click.stop.prevent="isOpen = true"
    />
    <template #content>
      <DjAddProductForm
        title="Ajouter à un devis"
        :icon="iconName"
        info="La quantité colis indiquée précédemment sera prise en compte dans votre devis."
        select-text="Sélectionnez un devis existante :"
        select-placeholder="Choisir un devis"
        create-text="Créez un nouveau devis :"
        input-placeholder="Nom de votre devis"
        :options="quoteList"
        @close="isOpen = false"
        @update="(selectedId: string) => addOrCreateToQuote('update', '', selectedId)"
        @create="(name: string) => addOrCreateToQuote('create', name, '')"
      />
    </template>
  </UModal>
</template>

<script setup lang="ts">
  const props = defineProps({
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    lines: {
      type: Array<{
        variantId: string;
        quantity: number;
      }>,
      required: true,
    },
  });

  const emit = defineEmits(['added', 'error']);
  const { addOrUpdateQuote } = useQuote();
  const { getUserCurrency } = useUser();
  const currency = computed(() => getUserCurrency());
  const iconName = 'i-heroicons-document-text';
  const isAdding = ref(false);
  const isOpen = ref(false);
  const quoteStore = useQuoteStore();
  const quoteList = computed(() =>
    quoteStore.quotes.filter((quote) => quote.supplierQuotes.length === 0)
  );

  const addOrCreateToQuote = async (
    actionType: 'create' | 'update',
    name: string,
    selectedId: string
  ) => {
    if (!props.isAuthenticated) return;
    try {
      isAdding.value = true;

      const response = await addOrUpdateQuote({
        currency: currency.value,
        actionType: actionType, // create or update
        quoteId: selectedId.length > 0 ? selectedId : undefined,
        name: name.length > 0 ? name : undefined,
        lines: props.lines, // Accepts multiple lines passed as a prop
      });

      emit('added', response); // Emit success event
      isOpen.value = false;
    } catch (error) {
      console.error('Failed to add products to cart:', error);
      emit('error', error); // Emit error event
      isOpen.value = false;
    } finally {
      isAdding.value = false;
    }
  };
</script>

<style lang="scss">
  .dj-add-to-quote-btn {
    font-family: var(--font-primary);
    font-size: 14px;
    font-weight: 700;
    color: white;
  }
</style>
